"use strict";
const cache = {};
export function memoize(key, fn, params, headers) {
  if (!cache[key]) {
    if (headers) {
      return fn(params ? params.join(",") : "", headers).then(data => {
        cache[key] = data;
        return data;
      });
    } else {
      return fn(params ? params.join(",") : "").then(data => {
        cache[key] = data;
        return data;
      });
    }
  }
  return new Promise((resolve, reject) => {
    resolve(cache[key]);
  });
}

export function memoizePlaylist(key, data) {
  localStorage[key] = data;
  return data;
}

export function isMemoized(key) {
  return localStorage[key];
}
